import { useSearchParams } from 'next/navigation';

import checkFlowType, { type TCheckFlowType } from '@/features/flowType/checkFlowType';

const useFlowType = (): TCheckFlowType => checkFlowType(useSearchParams()!);

export default useFlowType;
